import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../contexts/AuthContext';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { currentUser, logout } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = '/';
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  // Navigation items for public pages
  const publicNavItems = [
    { name: 'Anasayfa', path: '/' },
    { name: 'Hakkımda', path: '/about' },
    { name: 'Hizmetler', path: '/services' },
    { name: 'Hesaplama Araçları', path: '/tools' },
    { name: 'Blog', path: '/blog' },
    { name: 'Yorumlar', path: '/testimonials' },
    { name: 'İletişim', path: '/contact' },
  ];

  // Navigation items for admin pages
  const adminNavItems = [
    { name: 'Yönetim Paneli', path: '/admin' },
    { name: 'Blog Yönet', path: '/admin/blog' },
    { name: 'Kategoriler', path: '/admin/categories' },
    { name: 'Slaytlar', path: '/admin/slides' },
    { name: 'Yorumlar', path: '/admin/testimonials' },
  ];

  const currentPath = location.pathname;
  const isAdminPath = currentPath.startsWith('/admin');

  return (
    <motion.nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-md py-2' : 'bg-transparent py-4'
      }`}
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="container flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img 
            src="/assets/logo.png" 
            alt="Diyetisyen Nihal Kamış" 
            className="h-12 w-auto"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          {(isAdminPath ? adminNavItems : publicNavItems).map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`font-medium transition-colors duration-300 ${
                currentPath === item.path
                  ? 'text-nihal-primary'
                  : 'text-nihal-dark hover:text-nihal-primary'
              }`}
            >
              {item.name}
            </Link>
          ))}
          
          {currentUser && isAdminPath && (
            <button
              onClick={handleLogout}
              className="ml-4 px-4 py-2 bg-nihal-accent text-white rounded-lg hover:bg-opacity-90 transition-colors"
            >
              Logout
            </button>
          )}
          
          {/*{currentUser && !isAdminPath && (
            <Link
              to="/admin"
              className="ml-4 px-4 py-2 bg-nihal-primary text-white rounded-lg hover:bg-opacity-90 transition-colors"
            >
              Admin
            </Link>
          )}
		  */}
        </div>

        {/* Mobile menu button */}
        <div className="md:hidden flex items-center">
		{/*{!isAdminPath && currentUser && (
            <Link
              to="/admin"
              className="mr-4 px-3 py-1 bg-nihal-primary text-white rounded text-sm"
            >
              Admin
            </Link>
		)}*/}
          <button
            onClick={toggleMenu}
            className="text-nihal-dark focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <motion.div
          className="md:hidden bg-white shadow-lg"
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.3 }}
        >
          <div className="container py-4 flex flex-col space-y-3">
            {(isAdminPath ? adminNavItems : publicNavItems).map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`font-medium py-2 ${
                  currentPath === item.path
                    ? 'text-nihal-primary'
                    : 'text-nihal-dark'
                }`}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            
            {currentUser && isAdminPath && (
              <button
                onClick={() => {
                  handleLogout();
                  setIsMenuOpen(false);
                }}
                className="text-left font-medium py-2 text-nihal-dark"
              >
                Çıkış
              </button>
            )}
            {/*{currentUser && !isAdminPath && (
              <Link
                to="/admin"
                className="font-medium py-2 text-nihal-dark"
                onClick={() => setIsMenuOpen(false)}
              >
                Admin
              </Link>
            )}*/}
          </div>
        </motion.div>
      )}
    </motion.nav>
  );
};

export default Navbar;